
export const deviceTimelineFieldKeys = new Map([
    ['start_update', 'Start Firmware Update'],
    ['end_update', 'Firmware Update Finished'],
    ['update_dl_start', 'Start Download Firmware'],
    ['update_dl_fail', 'Firmware Download Failed'],
    ['sd_1', 'SD Absent'],
    ['sd_2', 'SD Inserted'],
    ['sd_3', 'SD Formated'],
    ['sd_4', 'SD Ok'],
    ['sd_5', 'SD Deffect'],
    ['sd_6', 'SD Incompatible'],
    ['sd_7', 'SD Too Small'],
]);
